// Utilitaire partagé de parsing des horaires d'ouverture d'un restaurant.
// Formats supportés : "11:30-14:00, 18:30-22:00" · "11h30-14h00; 18h30 à 22h00" · retours ligne.

// Retourne les plages horaires en minutes depuis minuit : [[startMin, endMin], ...]
export function parseOpeningHoursToRanges(text) {
  if (!text || typeof text !== "string") return [];
  const out = [];
  const rx = /(\d{1,2})[:h](\d{2})\s*[-–à]\s*(\d{1,2})[:h](\d{2})/gi;
  let m;
  while ((m = rx.exec(text)) !== null) {
    const start = parseInt(m[1], 10) * 60 + parseInt(m[2], 10);
    const end   = parseInt(m[3], 10) * 60 + parseInt(m[4], 10);
    if (isNaN(start) || isNaN(end) || end <= start) continue;
    out.push([start, end]);
  }
  return out;
}

// Retourne true si `now` (par défaut = maintenant) tombe dans l'une des plages d'ouverture.
// Si opening_hours_text est vide/invalide, retourne null (statut inconnu — n'affiche pas de badge).
export function isOpenNow(text, now = new Date()) {
  const ranges = parseOpeningHoursToRanges(text);
  if (ranges.length === 0) return null;
  const minutesNow = now.getHours() * 60 + now.getMinutes();
  return ranges.some(([start, end]) => minutesNow >= start && minutesNow < end);
}
